import * as React from 'react'
import { Button } from 'react-bootstrap'
import Footer from 'components/Footer'
import HeaderLarge from 'components/HeaderLarge'

const SceneComponent: React.FC = () => {
  return (
    <>
      <HeaderLarge title="ページが見つかりませんでした" />
      <div className="mt-5">
        <Button variant="link" href="/">
          トップへ戻る
        </Button>
      </div>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
